const actions = {
  SET_STATE: 'kirtan/SET_STATE',
  CREATE_KIRTAN: 'kirtan/CREATE_KIRTAN',
  GET_KIRTAN: 'kirtan/GET_KIRTAN',
  GET_KIRTAN_BY_ID: 'kirtan/GET_KIRTAN_BY_ID',
  DELETE_KIRTAN_BY_ID: 'kirtan/DELETE_KIRTAN_BY_ID',
  UPDATE_KIRTAN: 'kirtan/UPDATE_KIRTAN',
  RESET_STATE: 'kirtan/RESET_STATE',
}

export default actions
